<template>
  <div id="amenities">
    Amenities
    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sed iusto necessitatibus minus odit, quaerat omnis dolor nobis sapiente possimus voluptatum sequi nam? Fuga corporis natus corrupti, quas libero ad cumque.
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
#amenities{
    height: 300px;
    width: 85%;
    margin: auto;
    text-align: center;
    /* border: 1px solid black; */
}
</style>